import React from "react";
import { Box, Typography } from "@mui/material";
import TimePeriodSelection from "../../TimePeriodSelection";
import type { TimePeriod, TimePeriodSelection as TimePeriodSelectionType } from "@store/slices/donut-chart-config-slice";

interface TimePeriodSectionProps {
  timePeriodSelection: TimePeriodSelectionType;
  responsesMinDate?: string;
  responsesMaxDate?: string;
  datasetId?: string | null;
  isDisabled: boolean;
  onTimePeriodChange: (timePeriod: TimePeriod) => void;
  onTimePeriodDatesChange: (dates: {
    startDate: string | null;
    endDate: string | null;
  }) => void;
}

const TimePeriodSection: React.FC<TimePeriodSectionProps> = ({
  timePeriodSelection,
  responsesMinDate,
  responsesMaxDate,
  datasetId,
  isDisabled,
  onTimePeriodChange,
  onTimePeriodDatesChange,
}) => {
  return (
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
        Time Period
      </Typography>
      <TimePeriodSelection
        timePeriodSelection={timePeriodSelection}
        onTimePeriodChange={onTimePeriodChange}
        onTimePeriodDatesChange={onTimePeriodDatesChange}
        responsesMinDate={responsesMinDate}
        responsesMaxDate={responsesMaxDate}
        datasetId={datasetId}
        disabled={isDisabled}
      />
    </Box>
  );
};

export default TimePeriodSection;
